<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline">{{ $t('autoAdd.title') }}</h1>
          <hr />
          <auto-form />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import AutoForm from '@/components/auto/AutoForm/AutoForm.vue';
import hasPermission from '@/helpers/hasPermission';

export default {
  beforeRouteEnter(to, from, next) {
    if (hasPermission('car_add')) next();
    if (from.name !== 'autos-list') next({ name: 'autos-list' });
  },
  name: 'AddAutoPage',
  components: {
    AutoForm,
  },
  data() {
    return {};
  },
  computed: {},
};
</script>

<style lang="scss" scoped></style>
